<template>
  <BaseMenu
    :use-close-btn="false"
    :fixed="fixed"
    :fixed-on-page="fixedOnPage"
    :card-style="{ maxWidth: '24rem', minWidth: '24rem' }"
    card-class="tags-selector__tag-edit-menu"
    @close="$emit('close')"
  >
    <template v-slot:activator="{ on, active }">
      <slot name="activator" :on="on" :active="active"></slot>
    </template>

    <div>
      <div class="d-flex">
        <BaseInput
          :value="tag.name"
          @input="$emit('rename', tag, $event)"
        />
        <button
          class="base-btn ml-3 pa-0"
          @click="$emit('delete', tag)"
        >
          <BaseSvg name="ico-trash" width="1.4rem" height="1.6rem" />
        </button>
      </div>

      <div class="tags-selector__actions-menu-colors mt-5">
        <div
          v-for="([colorKey, styleEntry], styleIndex) in colorsEntriesMap.entries()"
          :key="styleIndex"
          :class="{ _selected: colorKey === tag.color }"
          :style="{ ...styleEntry }"
          @click="$emit('update-color', tag, colorKey)"
        >
          <BaseSvg v-if="colorKey === tag.color" name="ico-check" width="0.8rem" height="0.6rem" />
        </div>
      </div>
    </div>
  </BaseMenu>
</template>

<script>
export default {
  name: 'TagEditMenu',
  props: {
    colorsEntriesMap: {
      type: Map,
      required: true,
    },
    tag: {
      type: Object,
      required: true,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
    fixedOnPage: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
